import { render, staticRenderFns } from "./AttributeInput.vue?vue&type=template&id=7f245774&scoped=true"
import script from "./AttributeInput.vue?vue&type=script&lang=ts"
export * from "./AttributeInput.vue?vue&type=script&lang=ts"
import style0 from "./AttributeInput.vue?vue&type=style&index=0&id=7f245774&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f245774",
  null
  
)

export default component.exports